import {call, put, takeLatest} from 'redux-saga/effects';
import {
    RECOMMENDATION_QUERY_START,
    RecommendationQueryStartAction,
    getRecommendationQuerySuccessAction,
    getRecommendationQueryFailedAction
} from "../actions/RecommendationQueryAction";
import ApiUtil from "src/utils/ApiUtil";
import MetricsUtil from "src/utils/MetricsUtil";
import {RecommendationInfo} from "src/model/Recommendation";
import {RECOMMENDATION_FBA, RECOMMENDATION_LOWASP} from "src/config/Config";


export function* getRecommendation(action: RecommendationQueryStartAction) {
    try {
        let parameters: any = {countryCode: action.countryCode, asin: action.asin};
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "getrecommendations", parameters);
        const metricsUtil = MetricsUtil.getMetricsUtil();
        const recommendationInfos: Array<RecommendationInfo> = response.recommendationInfos;
        if (metricsUtil && recommendationInfos) {
            if (recommendationInfos.find(r => r.communicationType === RECOMMENDATION_FBA) != undefined) {
                metricsUtil.publishCounter('programRecommendation:FBA', "produce");
            }
            if (recommendationInfos.find(r => r.communicationType === RECOMMENDATION_LOWASP) != undefined) {
                metricsUtil.publishCounter('priceRecommendation', "produce");
            }
        }
        yield put(getRecommendationQuerySuccessAction(response));
    } catch (error) {
        console.error("Call API getrecommendations error" + error)
        yield put(getRecommendationQueryFailedAction());
        return;
    }
}

export default function* recommendation() {
    yield takeLatest(RECOMMENDATION_QUERY_START, getRecommendation);
}
